/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'cup': {
    width: 16,
    height: 16,
    viewBox: '0 0 100 100',
    data: '<path pid="0" d="M93.5 19.262a2.983 2.983 0 00-2.5-1.41H75.75l.71-4.27v-.004a3 3 0 00-3-3.488h-47a3.003 3.003 0 00-2.315 1.043 3.007 3.007 0 00-.684 2.445l.71 4.27L9 17.852a2.997 2.997 0 00-2.7 4.308L15 40a19.006 19.006 0 0015.14 10.5A21.185 21.185 0 0047 63.852v20.07H32.422c-1.66 0-3 1.34-3 3 0 1.656 1.34 3 3 3h35.156c1.66 0 3-1.344 3-3 0-1.66-1.34-3-3-3H53v-20.07a21.252 21.252 0 0010.25-4.387 21.203 21.203 0 006.602-8.984A19.006 19.006 0 0085 40l8.672-17.82a3 3 0 00-.172-2.918zM20.41 37.36l-6.57-13.508h11.41l3.379 20.281v-.004a12.91 12.91 0 01-8.22-6.77zm44.68 7.941a15.298 15.298 0 01-21.996 11.125 15.298 15.298 0 01-8.183-11.125L30 16.078h40zm14.5-7.941a12.909 12.909 0 01-8.219 6.77l3.38-20.282 11.41.004z"/>'
  }
})
